<template>
  <v-chip
    style="min-width: 50px"
    class="pl-2 pr-2"
    :disabled="(loading && !isSelectedItem) || disabled"
    @click.stop="flyTo(), setCurrentItem(item)"
    @dblclick.stop="setCurrentItem(null)"
    :style="`border: 1px solid ${item.properties.color};`"
    label
    size="x-small"
    var
    :variant="!isSelectedItem ? 'outlined' : 'flat'"
    :color="item.properties.color"
  >
    <v-progress-circular
      class="ml-3"
      v-if="loading && isSelectedItem"
      indeterminate
      size="10"
      width="2"
      color="white"
    >
    </v-progress-circular>
    <span v-else> {{ name ? item.properties.name : 'Section' }} </span>
  </v-chip>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { useEventsBus } from '@haskoning/vue-component-library'

const { emit } = useEventsBus()

export default {
  name: 'SectionChip',
  props: {
    item: {},
    name: { required: false, default: false },
    disabled: { required: false, default: false }
  },
  computed: {
    ...mapGetters({
      offset: 'dikeProfiles/getOffset'
    }),
    ...mapState('dikeSection', {
      currentDikeSection: (state) => state.currentItem
    }),
    ...mapState('dikeProfiles', {
      loading: (state) => state.loadingElevation,
      currentDikeProfile: (state) => state.currentItem
    }),
    isSelectedItem() {
      return this.currentDikeSection?.id === this.item.id
    }
  },
  methods: {
    flyTo() {
      emit('fly-to-dike-section', this.item)
    },
    ...mapActions('dikeSection', {
      setCurrentItem: 'setCurrentItem'
    })
  }
}
</script>
<style scoped></style>
